/*
 * A LINK'S SECRET IS SHOWN ONCE (docs/SHARING_SECURITY.md). The server keeps only a hash of it, so it cannot show a link again. The browser that made the link remembers it here, so the owner can copy or open it again
 * from the same browser; anywhere else the list says the link is not stored on this device. A per-browser convenience only (read and written inside try/catch; the page works without it).
 */
const KEY = "skydive.shareTokens";
const MAX = 200;

const read = (): Record<string, string> => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(KEY) || "{}");

    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};
const write = (map: Record<string, string>) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // it just will not be remembered
  }
};

export const rememberToken = (id: string, token: string) => {
  const map = read();
  map[id] = token;
  const ids = Object.keys(map);
  if (ids.length > MAX) ids.slice(0, ids.length - MAX).forEach((k) => delete map[k]);
  write(map);
};
export const recallToken = (id: string): string => {
  const token = read()[id];

  return typeof token === "string" && /^[A-Za-z0-9_-]{43}$/.test(token) ? token : "";
};
export const forgetToken = (id: string) => {
  const map = read();
  if (id in map) {
    delete map[id];
    write(map);
  }
};
